<script>
import { mapActions, mapState, mapGetters } from "vuex";

import orderMixin from "@/mixins/orderMixin";
import scrollMixin from "@/mixins/scrollMixin";

export default {
  mixins: [orderMixin, scrollMixin],

  data() {
    return {
      error: null
    };
  },

  methods: {
    ...mapActions("payable", [
      "resetPayment",
      "setPaymentData",
      "createOnGateway",
      "createPayment"
    ]),

    async submit() {
      this.error = null;

      const { type, starts_at, id } = this.payable;

      const data = {
        id,
        type: type.slice(0, -1),
        starts_at: starts_at,
        subscription: type === "cycles" ? this.payable.subscription : null
      };

      try {
        await this.setPaymentData(data);

        if (this.notCreatedOnGateway) {
          await this.createOnGateway();
        } else {
          await this.createPayment();
        }
      } catch (e) {
        this.error =
          "Não foi possível gerar o boleto, tente novamente. Entre em contato com o nosso suporte se o problema persistir!";
      }
    }
  },

  computed: {
    ...mapState("payable", ["payable"]),
    ...mapGetters("payable", ["notCreatedOnGateway"]),

    displayPaymentVoucherNotice: function() {
      let startsAt =
        this.payable.starts_at || this.payable.schedule_event.starts_at;

      return this.isInPeriodOfProofPayment(startsAt);
    }
  },

  mounted() {
    this.scrollTo("#boleto");
  }
};
</script>

<template>
  <div id="boleto" class="boleto">
    <img src="/static/boleto.svg" />
    <h3>Você quer mesmo gerar o boleto?</h3>

    <div class="warning" v-if="error">{{error}}</div>

    <p>Ao gerar o boleto não será mais possível pagar pelo cartão de crédito!</p>

    <div v-if="displayPaymentVoucherNotice">
      <hr />

      <p class="warning">
        Você deverá enviar o comprovante de pagamento através de ticket pois o seu pedido tem menos de {{daysToProvePayment}} dias úteis de antecedência.
      </p>

    </div>

    <div class="btn-group">
      <button class="btn bg-purple-outline" @click="resetPayment">Não, quero voltar</button>
      <button class="btn bg-purple" @click="submit">Sim, quero gerar o boleto</button>
    </div>
  </div>
</template>

<style scoped>
.boleto {
  display: flex;
  flex-direction: column;
  align-items: center;
}

img {
  height: 50px;
  width: 50px;
}

h3 {
  text-align: center;
  margin-top: 16px;
  margin-bottom: 8px;
  padding-bottom: 16px;
  font-weight: 500;
  border-bottom: solid 1px #af006b;
}

.warning {
  margin-top: 12px;
  border-left: solid 1px #af006b;
  color: #af006b;
  padding-left: 8px;
  font-size: 12px;
}

p {
  text-align: center;
  font-size: 16px;
}

hr {
  width: 50px;
  border: 1px solid var(--pink);
}
.warning {
  font-size: 14px;
  color: var(--pink);
}
</style>



// WEBPACK FOOTER //
// src/components/_Shared/CheckoutMobile/Payment/PaymentOptions/Boleto.vue